import * as review from './types';

const getters = {
  [review.REVIEW]: state => state.review,
  [review.REVIEWS]: state => state.reviews,
  [review.REPORTS]: state => state.reports,
  [review.REVIEW_COUNT]: state => state.reviews.content.length,
};

export default getters;
